import React, { useContext } from "react";
import { Navigate } from "react-router";
import { AuthContext, IntlContext, ListContext } from "context";
import { fetchProviderFavorites } from "hooks/profile";
import { ListProvider, ListWrapper } from "components/List";
import ComponentList from "app/OurService/List/ComponentList";
import type { ServiceInterface } from "types/service";
import { Role } from "types/user";
import { ROUTES } from "routes";

const ProviderFavoritesGrid: React.FC = () => {
    const { data } = useContext(ListContext);

    return <ComponentList items={data as ServiceInterface[]} />;
};

const MyProviders: React.FC = () => {
    const intl = useContext(IntlContext);
    const { currentRole } = useContext(AuthContext);

    if (currentRole !== Role.CLIENT) {
        return <Navigate to={ROUTES.ACCOUNT_PROFILE} replace />;
    }

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="mb-6">
                <h2 className="text-xl font-bold text-slate-900">
                    {intl.formatMessage("profile.nav.my_providers")}
                </h2>
                <p className="text-sm text-slate-500">
                    {intl.formatMessage("profile.my_providers.description")}
                </p>
            </div>

            <ListProvider dataFetcher={fetchProviderFavorites} cacheKey="provider-favorites">
                <ListWrapper
                    className="rounded-none border-0 bg-transparent shadow-none"
                    ToolBarComponent={() => null}
                    noResultsLabel={intl.formatMessage("profile.my_providers.empty")}
                    emptyStateClassName="rounded-xl bg-slate-50 p-4 text-sm text-slate-500"
                >
                    <ProviderFavoritesGrid />
                </ListWrapper>
            </ListProvider>
        </section>
    );
};

export default MyProviders;
